module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 col-sm-2"
  }, [_c('p', {
    staticClass: "text grey phrase"
  }, [_vm._v(_vm._s(_vm.$t("$form.phrase")))])]), _c('div', {
    staticClass: "col-6 col-sm-4 col-lg-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('text-input', {
    staticClass: "col-6 col-sm-2",
    attrs: {
      "label": _vm.$t('$form.fields.name.label'),
      "placeholder": _vm.$t('$form.fields.name.placeholder')
    },
    model: {
      value: (_vm.formdata.name),
      callback: function($$v) {
        _vm.formdata.name = $$v
      },
      expression: "formdata.name"
    }
  }), _c('text-input', {
    staticClass: "col-6 col-sm-4",
    attrs: {
      "label": _vm.$t('$form.fields.contact.label'),
      "placeholder": _vm.$t('$form.fields.contact.placeholder')
    },
    model: {
      value: (_vm.formdata.contact),
      callback: function($$v) {
        _vm.formdata.contact = $$v
      },
      expression: "formdata.contact"
    }
  }), _c('file-input', {
    staticClass: "col-6 col-sm-2",
    attrs: {
      "label": _vm.$t('$form.fields.photos.label'),
      "placeholder": _vm.$t('$form.fields.photos.placeholder[0]'),
      "extensions": ".jpg, .jpeg, .png"
    },
    model: {
      value: (_vm.formdata.photos.portrait),
      callback: function($$v) {
        _vm.formdata.photos.portrait = $$v
      },
      expression: "formdata.photos.portrait"
    }
  }), _c('file-input', {
    staticClass: "col-6 col-sm-2",
    attrs: {
      "placeholder": _vm.$t('$form.fields.photos.placeholder[1]'),
      "extensions": ".jpg, .jpeg, .png"
    },
    model: {
      value: (_vm.formdata.photos.fullGrowth),
      callback: function($$v) {
        _vm.formdata.photos.fullGrowth = $$v
      },
      expression: "formdata.photos.fullGrowth"
    }
  }), _c('file-input', {
    staticClass: "col-6 col-sm-2",
    attrs: {
      "placeholder": _vm.$t('$form.fields.photos.placeholder[2]'),
      "extensions": ".jpg, .jpeg, .png"
    },
    model: {
      value: (_vm.formdata.photos.side),
      callback: function($$v) {
        _vm.formdata.photos.side = $$v
      },
      expression: "formdata.photos.side"
    }
  }), _c('textarea-input', {
    staticClass: "col-6",
    attrs: {
      "label": _vm.$t('$form.fields.comment.label'),
      "placeholder": _vm.$t('$form.fields.comment.placeholder')
    },
    model: {
      value: (_vm.formdata.comment),
      callback: function($$v) {
        _vm.formdata.comment = $$v
      },
      expression: "formdata.comment"
    }
  }), _c('div', {
    staticClass: "col-auto ml-auto"
  }, [_c('button', {
    staticClass: "main",
    on: {
      "click": _vm.sendData
    }
  }, [_vm._v(_vm._s(_vm.$t('$form.button')))])])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f8153f9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/UserForm.vue
// module id = 41
// module chunks = 7